import Vue from "vue";
import { fetchRequest } from "@/plugins/fetchRequest";
// import { mockedAdvertiser } from "@/mockedData";

const actions = {
  signup({ commit }: StoreProp, payload: BodyInit) {
    return new Promise((resolve, reject) => {
      fetchRequest({ url: "/signUp", method: "post", body: payload })
        .then((responseData = {}) => {
          if (commit) {
            resolve(responseData);
          }
        })
        .catch((err: UnknownObj) => {
          reject(err);
        });
    });
  },
  recovery({ commit }: StoreProp, payload: BodyInit) {
    return new Promise((resolve, reject) => {
      fetchRequest({ url: "/forgotPassword", method: "post", body: payload })
        .then((responseData = {}) => {
          if (commit) {
            resolve(responseData.data || responseData);
          }
        })
        .catch((err: UnknownObj) => {
          reject(err);
        });
    });
  },
  password({ commit }: StoreProp, payload: BodyInit) {
    return new Promise((resolve, reject) => {
      fetchRequest({ url: "/recoverPassword", method: "post", body: payload })
        .then((responseData = {}) => {
          if (commit) {
            resolve(responseData.data || responseData);
          }
        })
        .catch((err: UnknownObj) => {
          reject(err);
        });
    });
  },
  resendConfirmationEmail({ commit }: StoreProp, user: string) {
    return new Promise((resolve, reject) => {
      fetchRequest({
        url: `/emailConfirmation/${user}?resend=1`,
        method: "get"
      })
        .then(res => {
          if (commit) {
            resolve(res);
          }
        })
        .catch((e: UnknownObj) => {
          reject(e);
        });
    });
  },
  getProfile({ commit }: StoreProp) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
        .then(async (response: UnknownObj) => {
          const tmpUserInfo = response?.signInUserSession?.idToken?.payload;
          const userGroup = tmpUserInfo?.["cognito:groups"] || [];
          const group = userGroup?.[0];

          if (["admin", "basic"].includes(group)) {
            const companyId = tmpUserInfo["custom:companyId"];

            commit && commit("UPDATE_PROFILE", { companyId });

            fetchRequest({
              url: "/user",
              method: "get"
            })
              .then((responseData = {}) => {
                if (commit) {
                  const profile: Profile =
                    responseData?.data || responseData || {};
                  commit("UPDATE_PROFILE", profile);
                  resolve(profile);
                }
              })
              .catch((err: UnknownObj) => {
                reject(err);
              });
          } else {
            console.error(`Invalid user group "${group}"`);
          }
        })
        .catch(() => {
          reject();
        });
    });
  },
  setProfile({ commit }: StoreProp, payload: UnknownObj) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
        .then(async (response: UnknownObj) => {
          const tmpUserInfo = response.signInUserSession.idToken.payload;
          const userGroup = tmpUserInfo["cognito:groups"] || [];

          if (userGroup.includes("admin")) {
            const companyId = tmpUserInfo["custom:companyId"];

            commit && commit("UPDATE_PROFILE", { companyId });

            fetchRequest({
              url: "/user",
              method: "patch",
              body: payload as BodyInit
            })
              .then((responseData = {}) => {
                if (commit) {
                  const profile: Profile =
                    responseData.data || responseData || {};
                  commit("UPDATE_PROFILE", profile);
                  resolve(profile);
                }
              })
              .catch((err: UnknownObj) => {
                reject(err);
              });
          }
        })
        .catch(() => {
          reject();
        });
    });
  }
};

export default actions;
